import React, { useMemo, useState } from 'react';
import { projects } from '../../data/constants';
import SectionHeading from '../common/SectionHeading';
import ProjectCard from '../Cards/ProjectCards';
import {
  Container,
  BackgroundAccent,
  Wrapper,
  ToggleButtonGroup,
  ToggleButton,
  CardContainer,
  GradientFade,
} from './ProjectsStyle';

const filters = [
  { label: 'All', value: 'all' },
  { label: 'Web Apps', value: 'web app' },
  { label: 'Android Apps', value: 'android app' },
  { label: 'Machine Learning', value: 'machine learning' },
];

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');

  const filteredProjects = useMemo(
    () => (toggle === 'all' ? projects : projects.filter((item) => item.category === toggle)),
    [toggle],
  );

  return (
    <Container id="projects">
      <BackgroundAccent />
      <Wrapper>
        <SectionHeading
          eyebrow="Case Studies"
          title="Selected work across products, platforms, and AI initiatives"
          description="A cross-section of production launches, prototypes, and research spikes spanning enterprise tools, consumer experiences, and ML systems."
        />
        <ToggleButtonGroup>
          {filters.map(({ label, value }) => (
            <ToggleButton
              key={value}
              type="button"
              active={toggle === value}
              onClick={() => setToggle(value)}
            >
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <CardContainer>
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.id || project.title}
              project={project}
              openModal={openModal}
              setOpenModal={setOpenModal}
            />
          ))}
        </CardContainer>
      </Wrapper>
      <GradientFade aria-hidden="true" />
    </Container>
  );
};

export default Projects;
